import { render, staticRenderFns } from "./BarkhausenEffectViz.vue?vue&type=template&id=2e80defd&scoped=true"
import script from "./BarkhausenEffectViz.vue?vue&type=script&lang=js"
export * from "./BarkhausenEffectViz.vue?vue&type=script&lang=js"
import style0 from "./BarkhausenEffectViz.vue?vue&type=style&index=0&id=2e80defd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e80defd",
  null
  
)

export default component.exports